import React from 'react';
import classNames from 'classnames';
import './Button.css';

export function Button({ 
  children,
  variant = 'primary',
  size = 'md',
  icon = null,
  iconPosition = 'left',
  loading = false,
  disabled = false,
  className = '',
  ...props
}) {
  const buttonClasses = classNames(
    'agrisense-button',
    `agrisense-button--${variant}`,
    `agrisense-button--${size}`,
    {
      'agrisense-button--loading': loading,
      'agrisense-button--icon-right': iconPosition === 'right',
    },
    className
  );

  return (
    <button 
      className={buttonClasses} 
      disabled={disabled || loading}
      data-testid="button"
      {...props}
    >
      {loading ? (
        <span className="agrisense-button__spinner"></span>
      ) : (
        <>
          {icon && iconPosition === 'left' && (
            <span className="agrisense-button__icon">{icon}</span>
          )}
          <span className="agrisense-button__content">{children}</span>
          {icon && iconPosition === 'right' && (
            <span className="agrisense-button__icon">{icon}</span>
          )}
        </>
      )}
    </button>
  );
}